import { VoiceAgentConfigurationModelVoice, VoiceAgentLanguage } from '~/api/graphql';

export const voiceOptions = [
  {
    value: VoiceAgentConfigurationModelVoice.Charlotte,
    label: 'Charlotte',
    description: 'Southern accent, warm and friendly'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Chloe,
    label: 'Chloe',
    description: 'Clear and professional'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Cimo,
    label: 'Cimo',
    description: 'Modern and versatile'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Eleanor,
    label: 'Eleanor',
    description: 'Midwest accent, approachable'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Evie,
    label: 'Evie',
    description: 'Mandarin accent, calm'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Grace,
    label: 'Grace',
    description: 'Elegant and sophisticated'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Isabel,
    label: 'Isabel',
    description: 'Spanish accent, warm'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Kate,
    label: 'Kate',
    description: 'Crisp and articulate'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Marissa,
    label: 'Marissa',
    description: 'Smooth and calming'
  },
  {
    value: VoiceAgentConfigurationModelVoice.May,
    label: 'May',
    description: 'Young Chinese voice'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Susan,
    label: 'Susan',
    description: 'Mature and trustworthy'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Zuri,
    label: 'Zuri',
    description: 'Energetic and engaging'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Ashley,
    label: 'Ashley',
    description: 'Warm and conversational'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Crystal,
    label: 'Crystal',
    description: 'Clear and bright'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Hailey,
    label: 'Hailey',
    description: 'Friendly and approachable'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Nia,
    label: 'Nia',
    description: 'Confident and articulate'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Rita,
    label: 'Rita',
    description: 'Professional and polished'
  },
  {
    value: VoiceAgentConfigurationModelVoice.Sophie,
    label: 'Sophie',
    description: 'Gentle and soothing'
  },
  {
    value: VoiceAgentConfigurationModelVoice.MinimaxGrace,
    label: 'Grace',
    description: 'Elegant and refined'
  }
];

export const responsivenessOptions = [
  { value: 0.7, label: 'Deliberate' },
  { value: 0.75, label: 'Measured' },
  { value: 0.85, label: 'Balanced' },
  { value: 0.9, label: 'Quick' },
  { value: 1.0, label: 'Immediate' }
];

export const voiceSpeedOptions = [
  { value: 0.8, label: 'Very Slow' },
  { value: 0.96, label: 'Slow' },
  { value: 1.06, label: 'Normal' },
  { value: 1.2, label: 'Fast' },
  { value: 1.3, label: 'Very Fast' }
];

export const voiceTemperatureOptions = [
  { value: 0.1, label: 'Flat' },
  { value: 0.5, label: 'Subtle' },
  { value: 1.0, label: 'Natural' },
  { value: 1.5, label: 'Expressive' },
  { value: 2.0, label: 'Very Expressive' }
];

export const voiceVolumeOptions = [
  { value: 0.5, label: 'Quiet' },
  { value: 0.75, label: 'Soft' },
  { value: 1.0, label: 'Normal' },
  { value: 1.25, label: 'Loud' },
  { value: 1.5, label: 'Very Loud' }
];

export const isMinimaxOnlyLanguage = (language: VoiceAgentLanguage): boolean => {
  return (
    language === VoiceAgentLanguage.ThTh ||
    language === VoiceAgentLanguage.RoRo ||
    language === VoiceAgentLanguage.BgBg ||
    language === VoiceAgentLanguage.CaEs ||
    language === VoiceAgentLanguage.HuHu ||
    language === VoiceAgentLanguage.ZhCn ||
    language === VoiceAgentLanguage.ViVn ||
    language === VoiceAgentLanguage.YueCn
  );
};

export const isMinimaxVoice = (voice: VoiceAgentConfigurationModelVoice): boolean => {
  return (
    voice === VoiceAgentConfigurationModelVoice.May ||
    voice === VoiceAgentConfigurationModelVoice.Ashley ||
    voice === VoiceAgentConfigurationModelVoice.Crystal ||
    voice === VoiceAgentConfigurationModelVoice.Hailey ||
    voice === VoiceAgentConfigurationModelVoice.Nia ||
    voice === VoiceAgentConfigurationModelVoice.Rita ||
    voice === VoiceAgentConfigurationModelVoice.Sophie ||
    voice === VoiceAgentConfigurationModelVoice.MinimaxGrace
  );
};

export const isElevenLabsVoice = (voice: VoiceAgentConfigurationModelVoice): boolean => {
  return !isMinimaxVoice(voice);
};

export const getDefaultVoiceForLanguage = (
  language: VoiceAgentLanguage
): VoiceAgentConfigurationModelVoice => {
  if (language === VoiceAgentLanguage.YueCn) {
    return VoiceAgentConfigurationModelVoice.May;
  }
  if (language === VoiceAgentLanguage.ZhCn || language === VoiceAgentLanguage.ViVn) {
    return VoiceAgentConfigurationModelVoice.May;
  }
  if (
    language === VoiceAgentLanguage.ThTh ||
    language === VoiceAgentLanguage.RoRo ||
    language === VoiceAgentLanguage.BgBg ||
    language === VoiceAgentLanguage.CaEs ||
    language === VoiceAgentLanguage.HuHu
  ) {
    return VoiceAgentConfigurationModelVoice.Ashley;
  }
  return VoiceAgentConfigurationModelVoice.Grace;
};

export const filterVoiceOptionsForLanguage = (language?: VoiceAgentLanguage) => {
  if (!language) {
    return voiceOptions;
  }

  if (language === VoiceAgentLanguage.YueCn) {
    const mayOption = voiceOptions.find(
      (opt) => opt.value === VoiceAgentConfigurationModelVoice.May
    );
    return mayOption ? [mayOption] : [];
  }

  if (language === VoiceAgentLanguage.ZhCn || language === VoiceAgentLanguage.ViVn) {
    const mayOption = voiceOptions.find(
      (opt) => opt.value === VoiceAgentConfigurationModelVoice.May
    );
    const otherMinimaxOptions = voiceOptions.filter(
      (opt) => isMinimaxVoice(opt.value) && opt.value !== VoiceAgentConfigurationModelVoice.May
    );
    return mayOption ? [mayOption, ...otherMinimaxOptions] : otherMinimaxOptions;
  }

  if (
    language === VoiceAgentLanguage.ThTh ||
    language === VoiceAgentLanguage.RoRo ||
    language === VoiceAgentLanguage.BgBg ||
    language === VoiceAgentLanguage.CaEs ||
    language === VoiceAgentLanguage.HuHu
  ) {
    return voiceOptions.filter(
      (opt) => isMinimaxVoice(opt.value) && opt.value !== VoiceAgentConfigurationModelVoice.May
    );
  }

  if (language === VoiceAgentLanguage.Multi) {
    return voiceOptions.filter((opt) => isElevenLabsVoice(opt.value));
  }

  return voiceOptions.filter((opt) => isElevenLabsVoice(opt.value));
};
